/* eslint-disable class-methods-use-this */
/* eslint-disable react/jsx-indent */
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { BaseTooltip } from 'cv-library-react-web';
import DropDown from '../DropDown';

export default class ActionDropDown extends PureComponent {
    static defaultProps = {
        contextStyles: {},
        items: [],
    };

    static propTypes = {
        /** Styles for this component */
        contextStyles: PropTypes.object,
        /** Items to present in the Drop Down */
        items: PropTypes.array,
        /** ItemSelectedId */
        itemSelected: PropTypes.object,
        /** Tooltip for hoovering over image */
        tooltip: PropTypes.string,
        /** Handler for pressing the image */
        onAction: PropTypes.func,
    };
        static formatStyleForDropDown(contextStyles) {
        return {
            dropDown: {
                ...contextStyles,
            },
        };
    }

    render() {
        const {
            contextStyles,
            items,
            itemSelected,
            tooltip,
        } = this.props;

        const styles = ActionDropDown.formatStyleForDropDown(contextStyles);

        return (
            <BaseTooltip tooltip={ tooltip }>
                <DropDown
                    key={ itemSelected?.id || itemSelected?.title || 'dropdown' }
                    items={ items }
                    onChange={ this.handleOnAction }
                    renderItem={ this.onHandleRenderItem }
                    renderInput={ () => itemSelected?.title || '' }
                    value={ itemSelected?.title }
                    contextStyles={ styles } />
            </BaseTooltip>
        );
    }

    onHandleRenderItem = (MenuItem, item) => (
        <MenuItem
            value={ item.name }
            text={ item.title }
            key={ item.id }
            item={ item } />
    );

    handleOnAction = (_, item) => {
        const { onAction } = this.props;
        if (onAction && item?.value && typeof item.value === 'object') {
            onAction(item.value);
        }
    };
}
